import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IChangePasswordDto } from 'src/app/core/models';
import { AuthService, ToastService, UserService } from 'src/app/core/services';
import { MustMatch } from 'src/app/core/validators/compare.validator';

@Component({
  selector: 'ic-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  public formErrors: any = {};
  public changePasswordForm: FormGroup;
  @Input() dialogData: any;
  public showPassword = true;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    public readonly activeDialog: NgbActiveModal,
    private readonly userService: UserService
  ) {}

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required, Validators.maxLength(30)]],
        password: ['', [Validators.required, Validators.maxLength(30)]],
        confirmPassword: ['', [Validators.required, Validators.maxLength(30)]],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );

    // This forces validation.
    Object.keys(this.changePasswordForm.controls).forEach((key) => {
      this.changePasswordForm.get(key).markAsTouched();
    });

    this.changePasswordForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.changePasswordForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });

    if (this.dialogData?.data) {
      const ctrl = this.changePasswordForm.get('oldPassword');
      ctrl.clearValidators();
      ctrl.updateValueAndValidity();
    }
  }

  get fc() {
    return this.changePasswordForm.controls;
  }

  changePassword() {
    if (!this.changePasswordForm.dirty) {
      this.toastService.showSuccess('Profile updated successfully');
      this.closeDialog();
      return;
    }

    const model: IChangePasswordDto = {
      ...this.changePasswordForm.value,
    };

    let payLoad = this.authService.changePassword(model);
    if (this.dialogData?.data) {
      const params = {
        key: this.dialogData.data,
        value: model.password,
      } as KeyValue<number, string>;
      payLoad = this.userService.changePassword(params);
    }

    payLoad.subscribe(
      (x) => {
        if (x.isSuccess) {
          if (x.responses[0]) {
            this.toastService.showError(x.responses[0]);
          }
          this.toastService.showSuccess('Password changed successfully');
          this.activeDialog.close(true);
        } else {
          this.toastService.showError(x.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  closeDialog() {
    this.activeDialog.close();
  }
}
